// extracted by mini-css-extract-plugin
export default {"button":"Form_button__FPW3m"};